import { all, call, put, takeEvery } from 'redux-saga/effects';

import GLOBAL_ERROR_MESSAGE from '@app/constants/errorMessages';
import workspaceService from '@app/libs/workspaceService';
import {
  DOCUMENT_FILE__DOWNLOAD_REQUEST,
  DOCUMENT_FILE__FETCH_REQUEST,
} from '@app/store/actionTypes';
import Document from '@app/store/document/Document';
import {
  downloadDocumentFile,
  downloadDocumentFileFailure,
  downloadDocumentFileSuccess,
  fetchDocumentFile,
  fetchDocumentFileFailure,
  fetchDocumentFileSuccess,
} from '@app/store/document/file/actions';
import { modalOpen } from '@app/store/modal/actions';
import { getDocumentsById } from '@app/store/transport-layer/document/documents';
import { getDocumentsFile } from '@app/store/transport-layer/document/documents/file';
import { downloadFileFromURLSaga } from '@app/store/transport-layer/files';

export function* downloadDocumentFileSaga({
  payload: { documentId, documentTitle },
}: ReturnType<typeof downloadDocumentFile>) {
  try {
    const workspaceId = workspaceService.getWorkspaceId();
    const { url }: { url: string } = yield call(getDocumentsFile, {
      workspaceId,
      documentId,
    });
    let fileName = null;
    if (documentTitle) {
      fileName = documentTitle;
    } else {
      const { name }: Document = yield call(getDocumentsById, {
        workspaceId: workspaceService.getWorkspaceId(),
        documentId,
      });
      fileName = name;
    }

    yield call(downloadFileFromURLSaga, {
      url,
      saveFileName: `${fileName || 'download'}.pdf`,
    });

    yield put(downloadDocumentFileSuccess());
  } catch (error) {
    yield put(downloadDocumentFileFailure(error));
    yield put(
      modalOpen('CONFIRM', {
        title: '문서 다운로드 실패',
        content: GLOBAL_ERROR_MESSAGE[error.message] || error.message,
      })
    );
  }
}

export function* fetchDocumentFileSaga({
  payload: { documentId },
}: ReturnType<typeof fetchDocumentFile>) {
  try {
    const workspaceId = workspaceService.getWorkspaceId();
    const { url }: { url: string } = yield call(getDocumentsFile, {
      documentId,
      workspaceId,
    });
    yield put(
      fetchDocumentFileSuccess({
        url,
      })
    );
  } catch (error) {
    yield put(fetchDocumentFileFailure(error));
  }
}

export default function* saga() {
  yield all([
    takeEvery(DOCUMENT_FILE__DOWNLOAD_REQUEST, downloadDocumentFileSaga),
    takeEvery(DOCUMENT_FILE__FETCH_REQUEST, fetchDocumentFileSaga),
  ]);
}
